'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminDashboardController', ['$scope', '$http', '$q', 'FilterState', function($scope, $http, $q, FilterState) {

  $scope.lastUpdate      = new Date();
  $scope.loadingStats    = true;
  $scope.lastLogin       = null;
  $scope.activeFiltersCount = 0;
  $scope.activeFilterLabels = '';

  // ── Dernière connexion (localStorage) ──────────────────────────────────
  var VISIT_KEY = 'otfip_admin_prev_visit';
  try {
    var prevVisit = localStorage.getItem(VISIT_KEY);
    $scope.lastLogin = prevVisit ? new Date(prevVisit) : null;
    localStorage.setItem(VISIT_KEY, new Date().toISOString());
  } catch (e) {}

  // ── Filtres actifs dans les autres pages ─────────────────────────────────
  var FILTER_PAGES = [
    { key: 'contrats',                  label: 'Contrats' },
    { key: 'autorisations',             label: 'Autor. Recherche' },
    { key: 'autorisations-exploitation',label: 'Autor. Exploitation' },
    { key: 'conventions',               label: 'Conventions' },
    { key: 'titres-miniers',            label: 'Titres Miniers' }
  ];
  (function() {
    var active = FILTER_PAGES.filter(function(p) {
      var f = FilterState.load(p.key);
      return f.q || f.type || f.statut || f.debut || f.fin;
    });
    $scope.activeFiltersCount = active.length;
    $scope.activeFilterLabels = active.map(function(p) { return p.label; }).join(', ');
  })();

  $scope.totals          = { documents: 0, petrole: 0, minier: 0, users: 0, grand: 0 };
  $scope.chartData       = { donut: [] };
  $scope.allModules      = [];
  $scope.recentActivity  = [];
  $scope.alerts          = [];
  $scope.alertCount      = 0;
  $scope.monthlyData     = [];
  $scope.monthlyPolyline = '';
  $scope.monthlyAreaPoints = '';

  var MODULES = {
    documents: [
      { label: 'Publications',      icon: 'fa-file-text-o',   color: '#3b82f6', state: 'admin.publications',             count: 0 },
      { label: 'Textes Officiels',  icon: 'fa-balance-scale', color: '#6366f1', state: 'admin.textes-officiels',         count: 0 }
    ],
    petrole: [
      { label: 'Contrats Pétroliers',        icon: 'fa-industry',    color: '#f59e0b', state: 'admin.contrats',                  count: 0 },
      { label: 'Autorisations Recherche',    icon: 'fa-search',      color: '#10b981', state: 'admin.autorisations',             count: 0 },
      { label: 'Autorisations Exploitation', icon: 'fa-cogs',        color: '#8b5cf6', state: 'admin.autorisations-exploitation', count: 0 }
    ],
    minier: [
      { label: 'Conventions Minières',   icon: 'fa-handshake-o', color: '#22c55e', state: 'admin.conventions-minieres',   count: 0 },
      { label: 'Titres Miniers',         icon: 'fa-id-card-o',   color: '#0ea5e9', state: 'admin.titres-miniers',         count: 0 },
      { label: 'Autorisations Minières', icon: 'fa-certificate', color: '#f97316', state: 'admin.autorisations-minieres', count: 0 }
    ]
  };
  $scope.modules = MODULES;

  // ── Helpers ───────────────────────────────────────────────────────────────
  function countItems(data) {
    if (!data) return 0;
    if (Array.isArray(data)) return data.length;
    return data.totalElements || data.totalItems ||
           (data.content ? data.content.length : 0) || 0;
  }

  function pct(val, total) {
    return total > 0 ? Math.round(val / total * 100) : 0;
  }

  // ── Graphiques SVG + CSS (aucune dépendance externe) ─────────────────────
  // Donut : SVG stroke-dasharray avec r=15.9155 → circonférence ≈ 100
  // Chaque segment : dashArray = "P (100-P)", dashOffset positionne le début
  function computeChartData() {
    var total = $scope.totals.grand || 1;
    var p0 = $scope.totals.documents / total * 100;
    var p1 = $scope.totals.petrole   / total * 100;
    var p2 = $scope.totals.minier    / total * 100;

    $scope.chartData.donut = [
      { label: 'Documents',         value: $scope.totals.documents, color: '#3b82f6',
        dashArray: p0.toFixed(2) + ' ' + (100 - p0).toFixed(2), dashOffset: 25 },
      { label: 'Secteur Pétrolier', value: $scope.totals.petrole,   color: '#f59e0b',
        dashArray: p1.toFixed(2) + ' ' + (100 - p1).toFixed(2), dashOffset: 25 - p0 },
      { label: 'Secteur Minier',    value: $scope.totals.minier,    color: '#22c55e',
        dashArray: p2.toFixed(2) + ' ' + (100 - p2).toFixed(2), dashOffset: 25 - p0 - p1 }
    ];

    // Barres CSS : progression relative au module le plus peuplé
    var all  = MODULES.documents.concat(MODULES.petrole).concat(MODULES.minier);
    var maxC = Math.max.apply(null, all.map(function(m){ return m.count; }).concat([1]));
    all.forEach(function(m){ m.barPct = Math.round(m.count / maxC * 100); });
    $scope.allModules = all;
  }

  // ── Helpers date ──────────────────────────────────────────────────────────
  function parseDateField(d) {
    if (!d) return null;
    if (Array.isArray(d)) return new Date(d[0], d[1] - 1, d[2]);
    var dt = new Date(d);
    return isNaN(dt.getTime()) ? null : dt;
  }

  $scope.formatDate = function(d) {
    var dt = parseDateField(d);
    if (!dt) return '—';
    var dd = dt.getDate(), mm = dt.getMonth() + 1, yy = dt.getFullYear();
    return (dd < 10 ? '0' + dd : dd) + '/' + (mm < 10 ? '0' + mm : mm) + '/' + yy;
  };

  // ── Activité récente ──────────────────────────────────────────────────────
  var ACT_MODULES = [
    { key: 'publications',         label: 'Publications',          icon: 'fa-file-text-o',   color: '#3b82f6', dateField: 'publicationDate', titleField: 'title' },
    { key: 'textes',               label: 'Textes Officiels',      icon: 'fa-balance-scale', color: '#6366f1', dateField: 'date',            titleField: 'title' },
    { key: 'contrats',             label: 'Contrats Pétroliers',   icon: 'fa-industry',      color: '#f59e0b', dateField: 'dateSignature',   titleField: 'denomination' },
    { key: 'autorisations',        label: 'Autor. Recherche',      icon: 'fa-search',        color: '#10b981', dateField: 'datePermis',      titleField: 'denomination' },
    { key: 'autorisationsExp',     label: 'Autor. Exploitation',   icon: 'fa-cogs',          color: '#8b5cf6', dateField: 'datePermis',      titleField: 'denomination' },
    { key: 'conventions',          label: 'Conventions Minières',  icon: 'fa-handshake-o',   color: '#22c55e', dateField: 'dateSignature',   titleField: 'societe' },
    { key: 'titres',               label: 'Titres Miniers',        icon: 'fa-id-card-o',     color: '#0ea5e9', dateField: 'dateAttribution', titleField: 'societe' },
    { key: 'autorisationsMinieres',label: 'Autor. Minières',       icon: 'fa-certificate',   color: '#f97316', dateField: 'dateAttribution', titleField: 'societe' }
  ];

  var EXP_MODULES = [
    { key: 'contrats',              label: 'Contrat Pétrolier',     icon: 'fa-industry',      color: '#f59e0b', expField: 'dateExpirationPrevue', titleField: 'denomination' },
    { key: 'autorisations',         label: 'Autor. Recherche',      icon: 'fa-search',        color: '#10b981', expField: 'dateExpirationPrevue', titleField: 'denomination' },
    { key: 'autorisationsExp',      label: 'Autor. Exploitation',   icon: 'fa-cogs',          color: '#8b5cf6', expField: 'dateExpirationPrevue', titleField: 'denomination' },
    { key: 'conventions',           label: 'Convention Minière',    icon: 'fa-handshake-o',   color: '#22c55e', expField: 'dateFin',              titleField: 'societe' },
    { key: 'titres',                label: 'Titre Minier',          icon: 'fa-id-card-o',     color: '#0ea5e9', expField: 'dateExpiration',       titleField: 'societe' },
    { key: 'autorisationsMinieres', label: 'Autor. Minière',        icon: 'fa-certificate',   color: '#f97316', expField: 'dateExpiration',       titleField: 'societe' }
  ];

  function computeRecentActivity(allData) {
    var items = [];
    ACT_MODULES.forEach(function(m) {
      (allData[m.key] || []).forEach(function(item) {
        var dt = parseDateField(item[m.dateField]);
        if (!dt) return;
        items.push({ module: m.label, icon: m.icon, color: m.color,
          title: item[m.titleField] || item.title || '—',
          dateObj: dt, dateFormatted: $scope.formatDate(item[m.dateField]) });
      });
    });
    items.sort(function(a, b) { return b.dateObj - a.dateObj; });
    $scope.recentActivity = items.slice(0, 3);
  }

  function computeAlerts(allData) {
    var now  = new Date();
    var in30 = new Date(now.getTime() + 30 * 24 * 60 * 60 * 1000);
    var list = [];
    EXP_MODULES.forEach(function(m) {
      (allData[m.key] || []).forEach(function(item) {
        var dt = parseDateField(item[m.expField]);
        if (!dt || dt < now || dt > in30) return;
        var days = Math.ceil((dt - now) / (24 * 60 * 60 * 1000));
        list.push({ module: m.label, icon: m.icon, color: m.color,
          title: item[m.titleField] || '—', expDate: dt, daysLeft: days, urgent: days <= 7 });
      });
    });
    list.sort(function(a, b) { return a.daysLeft - b.daysLeft; });
    $scope.alerts     = list;
    $scope.alertCount = list.length;
  }

  function computeMonthlyEvolution(allData) {
    var now    = new Date();
    var months = [];
    for (var i = 11; i >= 0; i--) {
      var d = new Date(now.getFullYear(), now.getMonth() - i, 1);
      months.push({ y: d.getFullYear(), m: d.getMonth() + 1,
        label: d.toLocaleDateString('fr-FR', { month: 'short' }).replace('.', ''), count: 0 });
    }
    var allItems = ACT_MODULES.reduce(function(acc, m) { return acc.concat(allData[m.key] || []); }, []);
    allItems.forEach(function(item) {
      var d = item.publicationDate || item.dateSignature || item.date || item.datePermis || item.dateAttribution;
      var dt = parseDateField(d);
      if (!dt) return;
      months.forEach(function(mo) {
        if (mo.y === dt.getFullYear() && mo.m === dt.getMonth() + 1) mo.count++;
      });
    });

    var maxC = Math.max.apply(null, months.map(function(m) { return m.count; }).concat([1]));
    var X0 = 44, X1 = 544, Y0 = 14, Y1 = 104;
    var W = X1 - X0, H = Y1 - Y0, step = W / (months.length - 1);
    months.forEach(function(m, i) {
      m.x = X0 + i * step;
      m.y = Y1 - (m.count / maxC) * H;
    });
    $scope.monthlyData     = months;
    $scope.monthlyPolyline = months.map(function(m) { return m.x.toFixed(1) + ',' + m.y.toFixed(1); }).join(' ');
    $scope.monthlyAreaPoints = $scope.monthlyPolyline +
      ' ' + X1 + ',' + Y1 + ' ' + X0 + ',' + Y1;
  }

  // ── Chargement ────────────────────────────────────────────────────────────
  function loadStats() {
    $scope.loadingStats = true;
    var fb = function() { return { data: [] }; };
    $q.all([
      $http.get('/api/publications').catch(fb),
      $http.get('/api/textes-officiels').catch(fb),
      $http.get('/api/contrats-petroliers').catch(fb),
      $http.get('/api/autorisations-recherche').catch(fb),
      $http.get('/api/autorisations-exploitation').catch(fb),
      $http.get('/api/conventions-minieres').catch(fb),
      $http.get('/api/titres-miniers').catch(fb),
      $http.get('/api/autorisations-minieres').catch(fb),
      $http.get('/api/admin/users?page=0&size=1').catch(function() { return { data: { totalElements: 0 } }; })
    ]).then(function(r) {
      function toArr(d) { return Array.isArray(d) ? d : (d && d.content ? d.content : []); }
      var allData = {
        publications:          toArr(r[0].data),
        textes:                toArr(r[1].data),
        contrats:              toArr(r[2].data),
        autorisations:         toArr(r[3].data),
        autorisationsExp:      toArr(r[4].data),
        conventions:           toArr(r[5].data),
        titres:                toArr(r[6].data),
        autorisationsMinieres: toArr(r[7].data)
      };

      MODULES.documents[0].count = allData.publications.length;
      MODULES.documents[1].count = allData.textes.length;
      MODULES.petrole[0].count   = allData.contrats.length;
      MODULES.petrole[1].count   = allData.autorisations.length;
      MODULES.petrole[2].count   = allData.autorisationsExp.length;
      MODULES.minier[0].count    = allData.conventions.length;
      MODULES.minier[1].count    = allData.titres.length;
      MODULES.minier[2].count    = allData.autorisationsMinieres.length;

      $scope.totals.users     = (r[8].data && r[8].data.totalElements) || 0;
      $scope.totals.documents = MODULES.documents.reduce(function(s,m){ return s+m.count; }, 0);
      $scope.totals.petrole   = MODULES.petrole.reduce(function(s,m){   return s+m.count; }, 0);
      $scope.totals.minier    = MODULES.minier.reduce(function(s,m){    return s+m.count; }, 0);
      $scope.totals.grand     = $scope.totals.documents + $scope.totals.petrole + $scope.totals.minier;

      $scope.totals.pctDocuments = pct($scope.totals.documents, $scope.totals.grand);
      $scope.totals.pctPetrole   = pct($scope.totals.petrole,   $scope.totals.grand);
      $scope.totals.pctMinier    = pct($scope.totals.minier,    $scope.totals.grand);

      var allCounts = MODULES.documents.concat(MODULES.petrole).concat(MODULES.minier).map(function(m){ return m.count; });
      var maxCount  = Math.max.apply(null, allCounts.concat([1]));
      MODULES.documents.forEach(function(m){ m.pct = Math.round(m.count / maxCount * 100); });
      MODULES.petrole.forEach(function(m){   m.pct = Math.round(m.count / maxCount * 100); });
      MODULES.minier.forEach(function(m){    m.pct = Math.round(m.count / maxCount * 100); });

      computeChartData();
      computeRecentActivity(allData);
      computeAlerts(allData);
      computeMonthlyEvolution(allData);

    }).finally(function() {
      $scope.loadingStats = false;
    });
  }

  $scope.refresh = function() { loadStats(); };

  loadStats();
}]);
